import { render, staticRenderFns } from "./ColumnConfig.vue?vue&type=template&id=144ac8b3&"
import script from "./ColumnConfig.vue?vue&type=script&lang=ts&"
export * from "./ColumnConfig.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./_locales/columnConfig.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fcomponents%2Fshared%2FColumnConfig.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports